import { MutationTree } from 'vuex';
import { Civilite, Compteur, CompteurState, initialState as resetState } from './state';
import { COMPTEUR } from '@/modules/Outils/store/mutation-types';

export const mutations: MutationTree<CompteurState> = {
    [COMPTEUR.SET_STEP](state, step: number){
        state.step = step;
    },
    [COMPTEUR.SET_RAISON_SOCIALE](state, raisonSociale: string){
        state.raisonSociale = raisonSociale;
    },
    [COMPTEUR.SET_NOM_COMMERCIAL](state, nomCommercial: string){
        state.nomCommercial = nomCommercial;
    },
    [COMPTEUR.SET_NUMERO_IDENTIFICATION](state, numeroIdentification: string){
        state.numeroIdentifiant = numeroIdentification;
    },
    [COMPTEUR.SET_ADRESSE_POSTALE](state, adressePostale: string){
        state.adressePostale = adressePostale;
    },
    [COMPTEUR.SET_CODE_POSTAL](state, codePostal: number){
        state.codePostal = codePostal;
    },
    [COMPTEUR.SET_VILLE](state, ville: string){
        state.ville = ville;
    },
    [COMPTEUR.SET_CIVILITE](state, civilite: Civilite){
        state.civilite = civilite;
    },
    [COMPTEUR.SET_NOM_REPRESENTANT](state, nomRepresentant: string){
        state.nomRepresentant = nomRepresentant;
    },
    [COMPTEUR.SET_PRENOM_REPRESENTANT](state, prenomRepresentant: string){
        state.prenomRepresentant = prenomRepresentant;
    },
    [COMPTEUR.SET_DATE_NAISSANCE_REPRESENTANT](state, ville: string){
        state.dateNaissanceRepresentant = ville;
    },
    [COMPTEUR.SET_MAIL_REPRESENTANT](state, mail: string){
        state.emailRepresentant = mail;
    },
    [COMPTEUR.SET_ADRESSE_REPRESENTANT_IDENTIQUE](state, isAdresseidentique: boolean){
        state.adresseRepresentantIdentique = isAdresseidentique;
    },
    [COMPTEUR.SET_ADRESSE_POSTALE_REPRESENTANT](state, adressePostaleRepresentant: string){
        state.adresseRepresentant = adressePostaleRepresentant;
    },
    [COMPTEUR.SET_CODE_POSTAL_REPRESENTANT](state, codePostalRepresentant: number){
        state.codePostalRepresentant = codePostalRepresentant;
    },
    [COMPTEUR.SET_VILLE_REPRESENTANT](state, villeRepresentant: string){
        state.villeRepresentant = villeRepresentant;
    },
    [COMPTEUR.ADD_COMPTEUR](state){
        state.compteurs?.push(new Compteur());
    },
    [COMPTEUR.SET_NUMERO_COMPTEUR](state, numeroCompteur: string){
        if (state.compteurs !== undefined) {
            state.compteurs[state.compteurs.length - 1].numeroCompteur = numeroCompteur;
        }
    },
    [COMPTEUR.ADD_FACTURE](state, file: File){
        if (state.compteurs !== undefined) {
            state.compteurs[state.compteurs.length - 1].facture = file;
        }
    },
    [COMPTEUR.REMOVE_FACTURE](state){
        if (state.compteurs !== undefined) {
            state.compteurs[state.compteurs.length - 1].facture = undefined;
        }
    },
    [COMPTEUR.REMOVE_COMPTEUR](state, compteur: Compteur){
        if (state.compteurs !== undefined) {
            const index = state.compteurs.findIndex(c => c === compteur);
            state.compteurs.splice(index, 1);
        }
    },
    [COMPTEUR.RESET](state){
        Object.assign(state, resetState);
        state.compteurs = [new Compteur()];
    },
};
